import { render, staticRenderFns } from "./OTSCredentialsConnection.vue?vue&type=template&id=06e168ff&scoped=true"
import script from "./OTSCredentialsConnection.vue?vue&type=script&lang=js"
export * from "./OTSCredentialsConnection.vue?vue&type=script&lang=js"
import style0 from "./OTSCredentialsConnection.vue?vue&type=style&index=0&id=06e168ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e168ff",
  null
  
)

export default component.exports